import axios from 'axios';
import AppConfig from "../../config/AppConfig";

function getBaseURL() {
  return AppConfig.track_server
}

const instance = axios.create({
  baseURL: getBaseURL() + ''
});

const ErrorResponse = {code: 400, msg: "网络错误"}

instance.interceptors.request.use(function (config) {
  if(!config.params) config.params = {}
  config.params.login_name = localStorage.getItem('login');
  config.params.token = localStorage.getItem('token');
  return config;
});

function DateFormat(date) {
  let year = date.getFullYear();
  let month = ("0" + (date.getMonth() + 1)).slice(-2);
  let sdate = ("0" + date.getDate()).slice(-2);
  return year + '-' + month + '-' + sdate;
}

function get(url, data, callback) {
  instance.get(url, {params: data}).then(resp => {
    callback(resp.data);
  }).catch(error => callback(ErrorResponse))
}

function post(url, data, callback) {
  instance.post(url, data).then(resp => {
    callback(resp.data);
  }).catch(error => callback(ErrorResponse))
}
export default class Track {
  static getBaseURL(){
    return getBaseURL()
  }
  static get(url, data, callback){
    get(url, data, callback)
  }
  static post(url, data, callback){
    post(url, data, callback)
  }
}



// WEBPACK FOOTER //
// ./src/assets/js/trackHttp.js